import { render, staticRenderFns } from "./YunpianVerifition.vue?vue&type=template&id=5d2d994f&scoped=true&"
import script from "./YunpianVerifition.vue?vue&type=script&lang=js&"
export * from "./YunpianVerifition.vue?vue&type=script&lang=js&"
import style0 from "./YunpianVerifition.vue?vue&type=style&index=0&id=5d2d994f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d994f",
  null
  
)

export default component.exports